import { request } from '../../../../api/requests/tuitionContinuityProcessManagement';
import { ReportAsyncTypeRow, ReportAsyncForm, ReportAsyncGroup } from './types';

export function getAsyncReports(group: ReportAsyncGroup) {
  return request<ReportAsyncTypeRow[]>('/maintainers-portal/reports/async', {
    params: { group },
  });
}

export function getReportForm(row: ReportAsyncTypeRow) {
  return request<ReportAsyncForm>(
    `/maintainers-portal/reports/async/${row.id}/form`,
  );
}

export function generateReport(row: ReportAsyncTypeRow, payload: any) {
  return request<ReportAsyncForm>(
    `/maintainers-portal/reports/async/${row.id}/generate`,
    { method: 'POST', data: payload },
  );
}
